import { useState, useEffect, useRef, useCallback } from 'react'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import './Module5World.scss'
import '../../Animations.css'

import MediaService from '../../services/MediaService'
import { getVideo } from '../../s3Func/s3Download'

import Practice from './DistancePractice'
import Module5Config from './Module5Config'
import { getUserContent, sleep } from '../../utils'
import WorldContainer from '../../components/World/WorldContainer'

import birdClosingGif from './bird_closing.gif'

const Module5World = () => {
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const { module5 } = useSelector((state) => state.module5, shallowEqual)
	const { login } = useSelector((state) => state.loginReducer, shallowEqual)
	const [slidesConfig, setSlidesConfig] = useState({})
	const [displayPracticeVideo, setDisplayPracticeVideo] = useState(false)
	const [showFinalAnimation, setShowFinalAnimation] = useState(false)
	const [showRewardSelection, setShowRewardSelection] = useState(false)

	const [birdClosingAudio, setBirdClosingAudio] = useState('')

	const [showEggAnimation, setShowEggAnimation] = useState(false)
	const [showEggCracked, setShowEggCracked] = useState(false)
	const [displayEndingVideo, setDisplayEndingVideo] = useState(false)

	const eggCracked = useRef()
	const eggTop = useRef()

	const WORLD_IMAGES = {
		progressBar0: '/Module5Images/Mod5_ProgressBar_0.svg',
		progressBar1: '/Module5Images/Mod5_ProgressBar_Third.svg',
		progressBar2: '/Module5Images/Mod5_ProgressBar_2Thirds.svg',
		progressBarCompleted: '/Module5Images/Mod5_ProgressBar_Completed.svg',
		keyReward: '/Module5Images/Worm.png',

		gift: '/Images/Gift.png',

		animal: '/Module5Images/Bird.png',
		worldBackground: '/Module5Images/bg_only.png',

		tree: '/Module5Images/tree.png',
		pond: '/Module5Images/pond.png',

		logoutBtn: '/Module1Images/Logout.png',
		journeyImage: '/Module1Images/bluejourneymap.svg',
	}

	const WORLD_REWARDS = {
		ButterflyBlue: '/Module5Images/Reward_ButterflyBlue.png',
		ButterflyPink: '/Module5Images/Reward_ButterflyOrange.png',
		Deer: '/Module5Images/Reward_DeerMale.png',
		Doe: '/Module5Images/Reward_DeerFemale.png',
		DuckColored: '/Module5Images/Reward_DuckMalard.png',
		DuckWhite: '/Module5Images/Reward_DuckWhite.png',
		BirdBlue: '/Module5Images/Reward_BirdBlue.png',
		BirdRed: '/Module5Images/Reward_BirdRed.png',
		Ladder: '/Module5Images/Reward_LadderStraight.png',
		Stairs: '/Module5Images/Reward_LadderWave.png',
		Swing: '/Module5Images/Reward_WoodenSwing.png',
		TelescopeBlue: '/Module5Images/Reward_TelescopeBlue.png',
		TelescopeRed: '/Module5Images/Reward_TelescopeRed.png',
		TireSwing: '/Module5Images/Reward_TireSwing.png',
		TreeHouseBlue: '/Module5Images/Reward_BirdhouseBlue.png',
		TreeHouseRed: '/Module5Images/Reward_BirdhousePink.png',
		Goggles: '/Module5Images/Reward_HatYellow.png',
		HardHat: '/Module5Images/Reward_HatBrown.png',
	}

	const CHARACTER_REWARDS = {
		Goggles: '/Module5Images/Reward_HatYellow.png',
		HardHat: '/Module5Images/Reward_HatBrown.png',
	}

	const TREE_REWARDS = {
		BirdBlue: '/Module5Images/Reward_BirdBlue.png',
		BirdRed: '/Module5Images/Reward_BirdRed.png',
		Ladder: '/Module5Images/Reward_LadderStraight.png',
		Stairs: '/Module5Images/Reward_LadderWave.png',
		Swing: '/Module5Images/Reward_WoodenSwing.png',
		TelescopeBlue: '/Module5Images/Reward_TelescopeBlue.png',
		TelescopeRed: '/Module5Images/Reward_TelescopeRed.png',
		TireSwing: '/Module5Images/Reward_TireSwing.png',
		TreeHouseBlue: '/Module5Images/Reward_BirdhouseBlue.png',
		TreeHouseRed: '/Module5Images/Reward_BirdhousePink.png',
	}

	const WORLD_ANIMATION = {
		egg: '/Module5Images/Egg.png',
		eggBottom: '/Module5Images/Egg+Crack+Bottom.png',
		eggHalfCracked: '/Module5Images/EggCrack_3.png',
		eggTop: '/Module5Images/Egg+Crack+Top.png',
		nest: '/Module5Images/Nest.png',
	}

	// Get AWS URL World Images
	Object.keys(WORLD_IMAGES).forEach((key) => {
		WORLD_IMAGES[key] = MediaService.getImage(WORLD_IMAGES[key], login)
	})

	// Get AWS URL Reward Images
	Object.keys(WORLD_REWARDS).forEach((key) => {
		WORLD_REWARDS[key] = MediaService.getImage(WORLD_REWARDS[key], login)
	})

	// Get AWS URL Reward Images
	Object.keys(CHARACTER_REWARDS).forEach((key) => {
		CHARACTER_REWARDS[key] = MediaService.getImage(
			CHARACTER_REWARDS[key],
			login
		)
	})

	// Get AWS URL Reward Images
	Object.keys(TREE_REWARDS).forEach((key) => {
		TREE_REWARDS[key] = MediaService.getImage(TREE_REWARDS[key], login)
	})

	// Get Animation Images
	Object.keys(WORLD_ANIMATION).forEach((key) => {
		WORLD_ANIMATION[key] = MediaService.getImage(WORLD_ANIMATION[key], login)
	})

	const createDistanceSlideShow = useCallback(async () => {
		const config = {
			navigate: '/listening',
			json: '',
			song: '',
			recording: '',
		}

		const { learn } = Module5Config[`day${module5.currentday}`]

		if (learn) {
			if (module5.currentday <= 4) {
				config.song = await getVideo(learn.song, login)
			} else {
				const userRecording = await getUserContent(
					learn.recording,
					module5.StudentID,
					login.influencerid,
					login
				  );
				  const song = await getUserContent(
					learn.song,
					module5.StudentID,
					login.influencerid,
					login
				  );
		  
				  const demoSong = await getUserContent(
					learn.demoSong,
					module5.StudentID,
					login.influencerid,
					login
				  );
				  fetch(userRecording).then((response) => {
					if (response.status === 200) {
					  config.recording = userRecording;
					  config.song = song;
					}
					else{
					  config.recording = null;
					  config.song = demoSong;
					}
		  
				  })
			}

			config.json = learn.json
			setSlidesConfig(config)
		}
	}, [])

	const handleFinalAnimationEnd = async () => {
		await sleep(500)

		dispatch({
			type: `MODULE5_SET_DAY_UNLOCK${module5.currentday + 1}`,
			payload: true,
		})

		dispatch({
			type: 'MODULE5_SET_dayCompleted',
			payload: module5.currentday,
		})

		if (module5.currentday !== 9) {
			dispatch({
				type: 'MODULE5_SET_stepCompleted',
				payload: 'notstarted',
			})
			await sleep(100);
			navigate('/distance/navigation')
		} else {
			setDisplayEndingVideo(true)
      		setShowRewardSelection(false)
		}
	}

	const rewardSelectionAnimation = async () => {
		const eggCrackAudio = MediaService.getVideo(
			'/Module5Videos/egg_crack.mp3',
			login
		)

		const eggCrackSound = new Audio(eggCrackAudio)
		eggCrackSound.play()

		setShowEggCracked(true)
		eggCracked.current.id = 'eggFade'
		await sleep(2000)

		setShowEggAnimation(true)
		await sleep(1000)
		eggTop.current.id = 'eggAnimate'

		eggCrackSound.onended = () => {
			setShowRewardSelection(true)
		}
	}

	const getBirdFinalAnimation = async () => {
		const dayFinishedAudio = await getVideo(
			'appfiles/distance/day_finished.mp3', login
		)
		setBirdClosingAudio(dayFinishedAudio)
	}

	const handleFinalAnimation = async () => {
		setShowRewardSelection(false)
		const finalAudio = new Audio(birdClosingAudio)
		finalAudio.play()
		await sleep(1000)
		setShowFinalAnimation(true)
		finalAudio.onended = handleFinalAnimationEnd
	}

	useEffect(() => {
		createDistanceSlideShow()
		getBirdFinalAnimation()
	}, [])

	// ==================== iOS Detection ====================
	const isIOS = () => {
		return [
		'iPad Simulator',
		'iPhone Simulator',
		'iPod Simulator',
		'iPad',
		'iPhone',
		'iPod'
		].includes(navigator.platform)
		// iPad on iOS 13 detection
		|| (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	}

	useEffect(() => {
		let timer;
		if (showEggAnimation && isIOS()) {
			timer = setTimeout(() => {
				setShowRewardSelection(true)
			}, 5000)
		}
		return () => {
			if (timer) clearTimeout(timer);
		}
	}, [showEggAnimation])

	useEffect(() => {
		let timer;
		if (showFinalAnimation && isIOS()) {
			timer = setTimeout(() => {
				handleFinalAnimationEnd()
			}, 5000)
		}
		return () => {
			if (timer) clearTimeout(timer);
		}
	}, [showFinalAnimation])

	return (
		<>
			<WorldContainer
				name={"Distance"}
				module={module5}
				moduleName="MODULE5"
				moduleConfig={Module5Config}
				slidesConfig={slidesConfig}
				keyIcon={'worm-reward'}
				practice={
					<Practice
						setDisplayPractice={() => setDisplayPracticeVideo(false)}
						background={WORLD_IMAGES.worldBackground}
						stepComplete="MODULE5_SET_stepCompleted"
						module={module5}
					/>
				}
				route="/distance"
				worldImages={WORLD_IMAGES}
				worldRewards={WORLD_REWARDS}
				showRewardSelection={showRewardSelection}
				uuid="distance"
				onPracticeClick={() => setDisplayPracticeVideo(true)}
				displayPracticeVideo={displayPracticeVideo}
				onRewardKeyClick={rewardSelectionAnimation}
				onRewardSelected={handleFinalAnimation}
				displayEndingVideo={displayEndingVideo}
			>
				<div className="world-assets">
					<figure className="tree">
						<img src={WORLD_IMAGES.tree} alt="tree" />
						<div className="tree-rewards">
							{module5.rewards.BirdBlue && (
								<img
									alt=""
									src={TREE_REWARDS.BirdBlue}
									className="world-rewards MODULE5 tree-rewards BirdBlue"
								/>
							)}
							{module5.rewards.BirdRed && (
								<img
									alt=""
									src={TREE_REWARDS.BirdRed}
									className="world-rewards MODULE5 tree-rewards BirdRed"
								/>
							)}
							{module5.rewards.Swing && (
								<img
									alt=""
									src={TREE_REWARDS.Swing}
									className="world-rewards MODULE5 tree-rewards Swing"
								/>
							)}
							{module5.rewards.TireSwing && (
								<img
									alt=""
									src={TREE_REWARDS.TireSwing}
									className="world-rewards MODULE5 tree-rewards TireSwing"
								/>
							)}
							{module5.rewards.Ladder && (
								<img
									alt=""
									src={TREE_REWARDS.Ladder}
									className="world-rewards MODULE5 tree-rewards Ladder"
								/>
							)}

							{module5.rewards.Stairs && (
								<img
									alt=""
									src={TREE_REWARDS.Stairs}
									className="world-rewards MODULE5 tree-rewards Stairs"
								/>
							)}
							{module5.rewards.TelescopeBlue && (
								<img
									alt=""
									src={TREE_REWARDS.TelescopeBlue}
									className="world-rewards MODULE5 tree-rewards TelescopeBlue"
								/>
							)}
							{module5.rewards.TelescopeRed && (
								<img
									alt=""
									src={TREE_REWARDS.TelescopeRed}
									className="world-rewards MODULE5 tree-rewards TelescopeRed"
								/>
							)}
							{module5.rewards.TreeHouseBlue && (
								<img
									alt=""
									src={TREE_REWARDS.TreeHouseBlue}
									className="world-rewards MODULE5 tree-rewards TreeHouseBlue"
								/>
							)}
							{module5.rewards.TreeHouseRed && (
								<img
									alt=""
									src={TREE_REWARDS.TreeHouseRed}
									className="world-rewards MODULE5 tree-rewards TreeHouseRed"
								/>
							)}
						</div>
						<div className="bird-character">
							<div>
								{module5.rewards.Goggles && (
									<img
										alt=""
										src={CHARACTER_REWARDS.Goggles}
										className="world-rewards MODULE5 character-rewards Goggles"
									/>
								)}
								{module5.rewards.HardHat && (
									<img
										alt=""
										src={CHARACTER_REWARDS.HardHat}
										className="world-rewards MODULE5 character-rewards HardHat"
									/>
								)}
								<figure
									className="bird-static"
								>
									<img src={WORLD_IMAGES.animal} alt="bird Icon" />
								</figure>
							</div>

							<figure
								className="bird-animation"
								style={{
									height: showFinalAnimation ? 'auto' : 0,
									opacity: showFinalAnimation ? 1 : 0,
								}}
							>
								<img src={birdClosingGif} alt="bird closing gif" />
							</figure>
						</div>
						<div className="egg-animation">
							<figure className="egg-animation__nest">
								<img src={WORLD_ANIMATION.nest} alt="nest" />
							</figure>

							{!showEggAnimation && (
								<figure className="egg-animation__egg">
									<img src={WORLD_ANIMATION.egg} alt="egg" />
								</figure>
							)}

							{!showEggAnimation && (
								<figure
									ref={eggCracked}
									className="egg-animation__egg--cracked"
									style={{
										height: showEggCracked ? 'auto' : 0,
										opacity: showEggCracked ? 1 : 0,
									}}
								>
									<img src={WORLD_ANIMATION.eggHalfCracked} alt="egg cracked" />
								</figure>
							)}

							<figure
								className="egg-animation__egg--top"
								ref={eggTop}
								style={{
									height: showEggAnimation ? 'auto' : 0,
									opacity: showEggAnimation ? 1 : 0,
								}}
							>
								<img src={WORLD_ANIMATION.eggTop} alt="egg top" />
							</figure>

							<figure
								className="egg-animation__egg--bottom"
								style={{
									height: showEggAnimation ? 'auto' : 0,
									opacity: showEggAnimation ? 1 : 0,
								}}
							>
								<img src={WORLD_ANIMATION.eggBottom} alt="egg bottom" />
							</figure>
						</div>
					</figure>
					<figure className="pond">
						<img src={WORLD_IMAGES.pond} alt="pond" />
					</figure>
				</div>


			</WorldContainer>
		</>
	)
}
export default Module5World
